var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationPalmtree = function SvgSimpleIllustrationPalmtree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D18000",
    d: "M22.468 17.471s1.096 9.78-.276 12.98c-1.372 3.198-3.473 10.054-3.383 10.785 0 0 .824 2.834 5.394 2.377 4.57-.457 4.57-1.92 4.57-1.92s1.006-18.737-.639-24.404c0 0-2.102-.73-3.198-.548-1.096.182-2.468.73-2.468.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    d: "M23.749 6.226s-3.017-2.01-7.496-.73c-4.479 1.281-8.134 8.501-8.5 9.78 0 0 7.495-1.554 9.688-1.372 0 0-4.57 5.118-4.204 10.511 0 0 6.305-7.586 12.247-7.859 5.942-.275 12.338 8.41 12.338 8.41s-.366-7.677-3.93-10.969l6.49 1.645S37.182 6.32 28.772 5.13c0 0-2.468-.366-5.027 1.096h.003Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.277 17.598c1.524 17.61-2.986 17.732-3.473 23.398"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.096 10.65s-8.958 3.474-8.958 14.625c0 0 4.388-8.044 12.429-8.592M29.043 10.65S38 14.124 38 25.275c0 0-4.388-8.044-12.43-8.592"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.807 40.996s.121 2.62 4.63 2.62c4.51 0 5.24-1.706 5.24-1.706 1.645-9.321-.366-24.494-.366-24.494M23.925 6.202c-4.51-2.805-12.187-1.463-16.45 9.506 0 0 5.362-2.072 10.114-1.95M24.046 6.202c6.094-3.84 13.685 2.388 16.451 9.506 0 0-3.016-1.165-6.528-1.697M24.277 9.51a5.203 5.203 0 0 1 1.851 3.518"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.085 37.522s3.168 2.377 9.019 0M21.793 32.707s3.289 1.463 7.435 0M22.669 27.057c1.325.303 3.59.537 6.19-.383M22.633 20.581c1.358.237 3.388.322 5.677-.485"
  })));
};
export default SvgSimpleIllustrationPalmtree;